/**
 * @file: getCustomerTypes.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { CustomerType } from '@euler/model/enum';

type CustomerTypeInfo = {
  name: string;
  shortName: string;
  isDefault?: boolean;
};

export const CustomerTypeInfoMap = new Map<CustomerType, CustomerTypeInfo>([
  [
    CustomerType.Default,
    { name: '普通私家车客户', shortName: '私家车', isDefault: true },
  ],
  [CustomerType.Official, { name: '公务车/单位车客户', shortName: '单位车' }],
]);

export function getCustomerTypeInfo(type: CustomerType) {
  return (
    CustomerTypeInfoMap.get(type) ??
    CustomerTypeInfoMap.get(CustomerType.Default)!
  );
}

export function getCustomerTypes(): Array<
  { type: CustomerType } & CustomerTypeInfo
> {
  return [...CustomerTypeInfoMap.entries()].map(([type, value]) => ({
    type,
    ...value,
  }));
}
